import './edit-payment-method.scss';
import { FaChevronLeft } from "react-icons/fa6";
import { FormProvider } from "react-hook-form";
import { ConfirmDialog } from "primereact/confirmdialog";

import SkeletonList from "@shared/ui/skeleton-list/skeleton-list";
import ErrorSection from "@shared/ui/error-section/error-section";
import HeaderContent from "@shared/ui/header-content/header-content";
import HeaderButton from "@shared/ui/header-button/header-button";

import FormPaymentMethod from "../form-payment-method/form-payment-method";
import { useEditPaymentMethod } from "./edit-payment-method.hook";

export function PaymentMethod() {
  const {
    paymentMethodData,
    isLoading,
    paymentMethodError,
    formMethod,
    actions,
    handleBack,
    handleAction,
  } = useEditPaymentMethod();

  const displayLoading = (
    <div className="card">
      <SkeletonList count={4} />
    </div>
  );
  const displayError = (
    <div className="card">
      <ErrorSection
        title="No Data"
        message="No data found in selected record. Please try again."
      />
    </div>
  );
  const mainContent = (
    <div>
      <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4 bg-white">
        <FormPaymentMethod />
      </section>
    </div>
  );

  return (
    <div id="PaymentMethod" className="payment-method">
      <HeaderContent
        title={ paymentMethodData?.name || "Edit Payment Method" }
        backIcon={<FaChevronLeft />}
        onBack={() => handleBack()}
      >
        <HeaderButton actions={actions} onAction={handleAction} />
      </HeaderContent>
      
      <section className="p-7">
        <ConfirmDialog />
        <FormProvider {...formMethod}>
          {isLoading && displayLoading}
          { paymentMethodError && !isLoading && displayError }
          {!isLoading ? mainContent : null}
         </FormProvider>
      </section>
    </div>
  );
}

export default PaymentMethod;